import { AbstractControl, ValidationErrors } from '@angular/forms';

export const RolesValidator = (control: AbstractControl): ValidationErrors | null => {
  const roleValues = control.value as boolean[];
  return roleValues.some((roleValue) => roleValue) ? null : { rolesRequired: { value: roleValues } };
};
